module.exports = "/_next/static/images/5513d2e004e8e090643085647afdfbc4-roxinho-basicos-flutuantes-lg@1x.png.webp";